import React, { useEffect, useState } from "react";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg"
import { useTranslation } from "react-i18next";

import getContentById from "../../../utils/getContentById";
import TeamLogo from "../../../../frontend/templates/_partials/TeamLogo";
import assets from "../../../../frontend/templates/fcb/ImageTable/assets";
import { StandingContent } from "../../../../frontend/templates/fcb/ImageTable/Index";
import { findRankStatusChangesV2 } from "../../../functions/standing";
import { UEFAStandingContent } from "../../../../frontend/templates/fcb/ImageTable/uefaStanding";
require("../../../../frontend/templates/fcb/ImageTable/style/style.scss");


function getSvgPoint(x, y, r = radius) {
    return `${getSvgX(y, r)},${getSvgY(x, r)}`;
}

export default function Index({ animation, data, mode, format, ...props }) {
    const { t } = useTranslation();

    const templateName = data?.template_name ?? "";
    const id = `${templateName}_${data?.uuid}`;
    const { options, fields, dynamic, editData } = data.data || {};

    const matchInfo = _.get(dynamic, "matchInfo");
    const competitionId = matchInfo?.competition?.id;
    const homeTeam = matchInfo?.contestant?.[0];
    const awayTeam = matchInfo?.contestant?.[1];

    const standing = _.get(dynamic, "standing");
    const played = _.get(dynamic, "played");
    const findGroup = _.find(standing, (group) => {
        return (
            _.find(group?.ranking, { contestantId: homeTeam?.id }) ||
            _.find(group?.ranking, { contestantId: awayTeam?.id })
        );
    });

    let firstRanking = [];
    if (findGroup?.ranking?.length) {
        firstRanking = findGroup?.ranking?.slice(0, 5);
    }

    const event = data?.event;
    const isUEFA = event.competitionId === "2mr0u0l78k2gdsm79q56tb2fo";
    const linesMarkersByRankType = findRankStatusChangesV2(
        findGroup?.ranking || [],
        [],
    );
    const selectedLang = data?.lang;
    return (

        <div className={`comp-template-preview ${props.customClass}`} style={{
            width: 0,
            height: 0
        }}>
            <div className="template-container">
                <div
                    id={id}
                    className="T_fcb_image_table"
                >
                    {
                        isUEFA && <div className="gradient-image"></div>
                    }
                    <div className={`wc-content content`}>
                        {
                            isUEFA ? <UEFAStandingContent
                                played={dynamic?.currentWeek}
                                content={findGroup?.ranking}
                                linesMarkersByRankType={linesMarkersByRankType}
                                startingIndex={0}
                                className={"first-group"}
                                competitionId={competitionId}
                                selectedLang={selectedLang}
                            /> : <StandingContent
                                played={dynamic?.currentWeek}
                                content={firstRanking}
                                linesMarkersByRankType={''}
                                startingIndex={0}
                                className={"first-group"}
                                competitionId={competitionId}
                                selectedLang={selectedLang}
                            />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}
